// Keep in sync with the active login route block in src/router/routes.js

// Classic login — comment SSO lines above and uncomment below to switch
let LOGIN_ROUTE_PATH = "/login"
let LOGIN_ROUTE_NAME = "Login"
const isSecurlySsoEnabled =
  String(import.meta.env.VITE_SECURLY_SSO_ENABLED ?? "true").toLowerCase() !==
  "false"

if (isSecurlySsoEnabled) {
  LOGIN_ROUTE_PATH = "/sso-login"
  LOGIN_ROUTE_NAME = "SsoLogin"
}

export const LOGIN_PAGE_PATHS = [
  "/sso-login",
  "/old-login",
  "/login",
  "/kiosk/login",
  "/kiosk/launch"
]

export const isLoginPagePath = (pathname = "") =>
  LOGIN_PAGE_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  )

export { LOGIN_ROUTE_PATH, LOGIN_ROUTE_NAME, isSecurlySsoEnabled }
